var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var QboMicrophone_1;
import { html, LitElement } from 'lit';
import { customElement, property } from 'lit/decorators.js';
/**
  * Collect text input from the user.
  */
let QboMicrophone = class QboMicrophone extends LitElement {
    constructor() {
        super(...arguments);
        this.renderInHost = true;
        this.continuous = false;
        this.interimResults = false;
        this.maxAlternatives = 1;
        this.for = 'input';
        this.class = 'input-group-text bi bi-headset';
        this.activeClass = 'bg-primary-subtle';
        this._recognition = null;
        this.target = null;
        this.listening = false;
    }
    static { QboMicrophone_1 = this; }
    static { this.activeInstance = null; }
    connectedCallback() {
        super.connectedCallback();
        this.addEventListener('click', this.listen);
        const recognition = new (window.SpeechRecognition || window.webkitSpeechRecognition)();
        recognition.continuous = this.continuous;
        // recognition.lang = 'en-US';
        recognition.interimResults = this.interimResults;
        recognition.maxAlternatives = this.maxAlternatives;
        recognition.onresult = (e) => { this.onResult(e); };
        recognition.onspeechend = (e) => { this.stop(e); };
        recognition.onerror = (e) => { this.error(e); };
        this._recognition = recognition;
        this.target = document.getElementById(this.for)
            || this.querySelector(this.for)
            || this.parentElement?.querySelector(this.for);
        if (this.target == null)
            console.log(`qbo-microphone: no target found for ${this.for}`);
    }
    disconnectedCallback() {
        this.removeEventListener('click', this.listen);
        super.disconnectedCallback();
    }
    onResult(e) {
        const text = e.results[e.results.length - 1][0].transcript; //e.results[0][0].transcript;
        console.log('Result: ' + text);
        if (this.target == null)
            return;
        const element = this.target;
        if (element instanceof HTMLInputElement) {
            if (element.type === 'radio') {
                if (element.value === text) {
                    element.checked = true;
                }
            }
            else {
                if (this.continuous)
                    element.value += text;
                else
                    element.value = text;
            }
        }
        else if (element instanceof HTMLTextAreaElement) {
            if (this.continuous)
                element.value += text;
            else
                element.value = text;
        }
        else if (element instanceof HTMLSelectElement) {
            for (let i = 0; i < element.options.length; i++) {
                if (element.options[i].value === text || element.options[i].text === text) {
                    element.selectedIndex = i;
                    break;
                }
            }
        }
    }
    listen(e) {
        if (this.listening)
            this.stop(e);
        else
            this.start();
    }
    start() {
        this.listening = true;
        QboMicrophone_1.activeInstance = this;
        if (this.activeClass)
            this.classList.add(this.activeClass);
        console.log('listening');
        this._recognition.start();
    }
    stop(e) {
        this.listening = false;
        QboMicrophone_1.activeInstance = null;
        if (this.activeClass)
            this.classList.remove(this.activeClass);
        console.log('stopped listening');
        this._recognition.stop();
        this._recognition.abort();
    }
    error(e) {
        console.log('Error during speech recognition:', e);
    }
    render() {
        return html `<slot></slot>`;
    }
};
__decorate([
    property({ type: Boolean }),
    __metadata("design:type", Object)
], QboMicrophone.prototype, "renderInHost", void 0);
__decorate([
    property({ type: Boolean }),
    __metadata("design:type", Object)
], QboMicrophone.prototype, "continuous", void 0);
__decorate([
    property({ type: Boolean }),
    __metadata("design:type", Object)
], QboMicrophone.prototype, "interimResults", void 0);
__decorate([
    property({ type: Number }),
    __metadata("design:type", Object)
], QboMicrophone.prototype, "maxAlternatives", void 0);
__decorate([
    property({ type: String }),
    __metadata("design:type", Object)
], QboMicrophone.prototype, "for", void 0);
__decorate([
    property({ type: String }),
    __metadata("design:type", Object)
], QboMicrophone.prototype, "class", void 0);
__decorate([
    property({ type: String }),
    __metadata("design:type", Object)
], QboMicrophone.prototype, "activeClass", void 0);
QboMicrophone = QboMicrophone_1 = __decorate([
    customElement('qbo-microphone')
], QboMicrophone);
export { QboMicrophone };
